// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auditpg-inline-1 {
  display: flex;
  gap: 6px;
}

.auditpg-inline-2 {
  width: 120px;
  padding: 5px 8px;
  font-size: 11px;
}

.auditpg-inline-3 {
  width: 160px;
  padding: 5px 8px;
  font-size: 11px;
}

.auditpg-inline-4 {
  padding: 0;
}

.auditpg-inline-5 {
  font-weight: 600;
}

.auditpg-dyn-1 {
  text-align: center;
  padding: 30px;
  color: var(--auditpg-1-color);
}

.auditpg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--auditpg-2-color);
}

.auditpg-dyn-3 {
  font-size: 11px;
  color: var(--auditpg-3-color);
}

.auditpg-dyn-4 {
  font-size: 11px;
  color: var(--auditpg-4-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/AuditPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":[".auditpg-inline-1 {\n  display: flex;\n  gap: 6px;\n}\n\n.auditpg-inline-2 {\n  width: 120px;\n  padding: 5px 8px;\n  font-size: 11px;\n}\n\n.auditpg-inline-3 {\n  width: 160px;\n  padding: 5px 8px;\n  font-size: 11px;\n}\n\n.auditpg-inline-4 {\n  padding: 0;\n}\n\n.auditpg-inline-5 {\n  font-weight: 600;\n}\n\n.auditpg-dyn-1 {\n  text-align: center;\n  padding: 30px;\n  color: var(--auditpg-1-color);\n}\n\n.auditpg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--auditpg-2-color);\n}\n\n.auditpg-dyn-3 {\n  font-size: 11px;\n  color: var(--auditpg-3-color);\n}\n\n.auditpg-dyn-4 {\n  font-size: 11px;\n  color: var(--auditpg-4-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
